var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"role":"region","aria-label":"header"}},[_c('h1',{staticClass:"title pa-2"},[_vm._v("Record not found.")])])
}]

export { render, staticRenderFns }